module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clients"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('div', {
    staticClass: "section-header"
  }, [_c('el-row', [_c('span', [_vm._v("Residents: " + _vm._s(_vm.clients.length))])])], 1)]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.clients,
      "default-sort": {
        prop: 'onSetDate',
        order: 'descending'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "",
      "label": " ",
      "width": "100"
    },
    scopedSlots: {
      default: function(scope) {
        return [_c('div', {
          staticStyle: {
            "padding": "0.5em"
          }
        }, [(scope.row.photo) ? _c('div', {
          staticClass: "profile-row-photo",
          attrs: {
            "span": 4
          }
        }, [_c('img', {
          attrs: {
            "src": _vm.photoUrl(scope.row.photo)
          }
        })]) : _c('div', {
          staticClass: "profile-row-photo",
          attrs: {
            "span": 4
          }
        }, [_c('img', {
          attrs: {
            "src": require("assets/user.png")
          }
        })])])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "Name",
      "sortable": "",
      "fixed": "",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [_vm._v("\n        " + _vm._s(_vm.clientName(scope.row)) + "\n      ")]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Gender",
      "width": "140"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.gender) ? _c('span', [_vm._v(_vm._s(scope.row.gender))]) : _c('span', [_vm._v("Not Entered")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "DOB",
      "prop": "dateOfBirth",
      "width": "180"
    },
    scopedSlots: {
      default: function(scope) {
        return [(scope.row.dateOfBirth) ? _c('span', [_vm._v(_vm._s(_vm._f("moment")(scope.row.dateOfBirth, 'DD-MM-YYYY')))]) : _c('span', [_vm._v("Not Entered")])]
      }
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Location"
    },
    scopedSlots: {
      default: function(scope) {
        return [(_vm.beds[scope.row.id]) ? _c('span', [_vm._v("\n        " + _vm._s(_vm.unitById(scope.row.unitId)) + " / " + _vm._s(_vm.beds[scope.row.id].displayText) + "\n        ")]) : _c('span', [_vm._v("\n        Not Assigned\n        ")])]
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a043216a!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Clients.vue
// module id = 251
// module chunks = 2